import { createContext, useContext, useEffect, useState, useCallback } from "react";

const RefreshContext = createContext(null);
const INTERVAL_MS = 5000;

export function RefreshProvider({ children }) {
  const [autoRefresh, setAutoRefresh] = useState(() => {
    try { return JSON.parse(localStorage.getItem("thrm_auto_refresh") || "true"); } catch { return true; }
  });
  const [tick, setTick] = useState(0);

  useEffect(() => { localStorage.setItem("thrm_auto_refresh", JSON.stringify(autoRefresh)); }, [autoRefresh]);

  const refreshNow = useCallback(() => setTick((t) => t + 1), []);

  useEffect(() => {
    if (!autoRefresh) return;
    const iv = setInterval(() => setTick((t) => t + 1), INTERVAL_MS);
    const refreshVisible = () => { if (document.visibilityState === "visible") setTick((t) => t + 1); };
    window.addEventListener("focus", refreshVisible);
    document.addEventListener("visibilitychange", refreshVisible);
    return () => {
      clearInterval(iv);
      window.removeEventListener("focus", refreshVisible);
      document.removeEventListener("visibilitychange", refreshVisible);
    };
  }, [autoRefresh]);

  return (
    <RefreshContext.Provider value={{ autoRefresh, setAutoRefresh, tick, refreshNow }}>
      {children}
    </RefreshContext.Provider>
  );
}

export function useRefresh() {
  return useContext(RefreshContext);
}
